import React, { useEffect, useRef, useState } from 'react'
import useIsMounted from '~hooks/useIsMounted'

const AnimatedLoadingDots: TAnimatedLoadingDots = () => {
	const animationIntervalRef = useRef<NodeJS.Timeout>(null)
	const rootRef = useRef<HTMLDivElement>()
	const [dotsNumber, setDotsNumber] = useState(3)
	const isMounted = useIsMounted()

	const animationLoop = () => {
		if (!isMounted()) {
			clearInterval(animationIntervalRef.current)
			return
		}

		setDotsNumber((dotsNumber) => 1 + (dotsNumber % 3))
	}

	useEffect(() => {
		rootRef.current.innerHTML = '...'
		const maxWidth = rootRef.current.offsetWidth
		rootRef.current.style.width = maxWidth + 'px'

		animationIntervalRef.current = setInterval(animationLoop, 500)
		return () => {
			clearInterval(animationIntervalRef.current)
		}
	}, [])

	return (
		<span
			className="AnimatedLoadingDots"
			ref={rootRef}
			style={{
				display: 'inline-block'
			}}
		>
			{[...new Array(dotsNumber)].map(() => '.').join('')}
		</span>
	)
}

export default AnimatedLoadingDots

type TAnimatedLoadingDots = React.FC
